import { gql } from "graphql-request"

export default gql`
    query ($siteId: [QueryArgument], $slug: [String], $draftId: Int, $revisionId: Int, $status: [String]) {
        data: entry(
            siteId: $siteId
            section: "htmlPages"
            slug: $slug
            draftId: $draftId
            revisionId: $revisionId
            status: $status
        ) {
            id
            title
            status
            ... on page_Entry {
                userStatus
                versionDraftIds: string
                showPageHeader
                pageBackgroundMedia {
                    url
                }
                seoMetaTitle
                seoMetaDescription
                colorMode
                leaderboardAd: leaderboardAd {
                    ... on ad3_Entry {
                        adUnit
                        sizes {
                            ... on sizesBlock_Entry {
                                width
                                height
                            }
                        }
                    }
                }
                matrix: pageMatrix {
                    ... on accordion_Entry {
                        type: typeHandle
                        style
                        identifier
                        showExpandAllButton
                        cssClasses
                        accordion: sections {
                            ... on sectionsBlock_Entry {
                                label
                                body
                            }
                        }
                    }
                    ... on body_Entry {
                        type: typeHandle
                        body
                        backgroundImage {
                            url
                        }
                        backgroundImageMobile {
                            url
                        }
                        bgMobileBreakpoint
                        backgroundColor
                        fullWidth
                        cssClasses
                    }
                    ... on twoColumn_Entry {
                        type: typeHandle
                        widths
                        columnOne
                        columnTwo
                        gap
                        cssClass
                        verticalColumnDivider
                    }
                    ... on wrapper_Entry {
                        type: typeHandle
                        customClass
                        entries {
                            ... on page_Entry {
                                id
                                pageMatrix {
                                    ... on body_Entry {
                                        type: typeHandle
                                        title
                                        body
                                        cssClasses
                                    }
                                    ... on accordion_Entry {
                                        type: typeHandle
                                        style
                                        identifier
                                        showExpandAllButton
                                        cssClasses
                                        accordion: sections {
                                            ... on sectionsBlock_Entry {
                                                label
                                                body
                                            }
                                        }
                                    }
                                    ... on row_Entry {
                                        type: typeHandle
                                        customClass
                                        addDividers
                                        gapHorizontal
                                        gapVerticalMobile
                                        columnsContent {
                                            ... on columnsContentBlock_Entry {
                                                columnContent
                                            }
                                        }
                                    }
                                    ... on twoColumn_Entry {
                                        type: typeHandle
                                        widths
                                        columnOne
                                        columnTwo
                                        gap
                                        cssClass
                                        verticalColumnDivider
                                    }
                                    ... on customComp_Entry {
                                        type: typeHandle
                                        component
                                        customClass
                                        json
                                        contentBlox {
                                            ... on contentBloxBlock_Entry {
                                                block
                                            }
                                        }
                                        parameters {
                                            value
                                        }
                                    }
                                }
                            }
                        }
                    }
                    ... on row_Entry {
                        type: typeHandle
                        customClass
                        addDividers
                        gapHorizontal
                        gapVerticalMobile
                        columnsContent {
                            ... on columnsContentBlock_Entry {
                                columnContent
                            }
                        }
                    }
                    ... on tabs_Entry {
                        type: typeHandle
                        identifier
                        tabs {
                            ... on tabsBlock_Entry {
                                label
                                labelColor
                                page {
                                    ... on page_Entry {
                                        id
                                        title
                                        matrix: pageMatrix {
                                            ... on accordion_Entry {
                                                type: typeHandle
                                                style
                                                identifier
                                                showExpandAllButton
                                                cssClasses
                                                accordion: sections {
                                                    ... on sectionsBlock_Entry {
                                                        label
                                                        body
                                                    }
                                                }
                                            }
                                            ... on body_Entry {
                                                type: typeHandle
                                                body
                                                cssClasses
                                            }
                                            ... on twoColumn_Entry {
                                                type: typeHandle
                                                widths
                                                columnOne
                                                columnTwo
                                            }
                                            ... on agendaSession_Entry {
                                                type: typeHandle
                                                eventId
                                                showSessionTitle
                                            }
                                            ... on faculty_Entry {
                                                type: typeHandle
                                                roles
                                                restrictionStatuses
                                                showFilters
                                            }
                                            ... on advancedAgenda_Entry {
                                                type: typeHandle
                                                showFilters
                                                showSearch
                                                showDownloadLinks
                                                openFirstSessionByDefault
                                                expandAllGroups
                                                doNotGroup
                                                onDemandOnly
                                                adjustForStreaming
                                                displayType
                                                sourceType
                                                identifiers
                                                excludeSessions
                                            }
                                            ... on row_Entry {
                                                type: typeHandle
                                                customClass
                                                addDividers
                                                gapHorizontal
                                                gapVerticalMobile
                                                columnsContent {
                                                    ... on columnsContentBlock_Entry {
                                                        columnContent
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    ... on agendaSession_Entry {
                        type: typeHandle
                        eventId
                        showSessionTitle
                    }
                    ... on faculty_Entry {
                        type: typeHandle
                        roles
                        restrictionStatuses
                        showFilters
                    }
                    ... on peopleGrid_Entry {
                        type: typeHandle
                        filter
                        color1
                        color2
                        json
                    }
                    ... on advancedAgenda_Entry {
                        type: typeHandle
                        showFilters
                        showSearch
                        showDownloadLinks
                        openFirstSessionByDefault
                        expandAllGroups
                        doNotGroup
                        onDemandOnly
                        adjustForStreaming
                        displayType
                        sourceType
                        identifiers
                        excludeSessions
                    }
                    ... on ad2_Entry {
                        type: typeHandle
                        adUnit
                        sizes {
                            ... on sizesBlock_Entry {
                                width
                                height
                            }
                        }
                    }
                    ... on customComp_Entry {
                        type: typeHandle
                        component
                        customClass
                        json
                        contentBlox {
                            ... on contentBloxBlock_Entry {
                                block
                            }
                        }
                        parameters {
                            value
                        }
                    }
                    ... on courseDirectors_Entry {
                        type: typeHandle
                        head
                        roles
                        rolesToSuppress
                        backgroundColor
                        highlightColor
                        fullWidth
                        layout
                        backgroundImage {
                            url
                        }
                    }
                }
            }
        }
    }
`
